<template>
  <div>
    <h1>Registrar Conductor</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
      <div class="text-center" v-if="$apollo.queries.getDrivers.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
      </div>
      <div v-else>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <label>Fotografía del conductor</label>
                  <base-image-input v-model="$v.imageData.$model" :imagen="getDriverById.profilePicture"/>
                  <small class="text-danger" v-if="!$v.imageData.required">Campo requerido. No debe estar vacío</small>
                  <br>
            </div>
            <div class="col">
              <div class="col-md">
              <a-form-item label="Nombre(s)">
                <a-input
                  placeholder="Nombre(s)"
                  v-model="$v.getDriverById.firstName.$model"
                />
                <small class="text-danger" v-if="!$v.getDriverById.firstName.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!$v.getDriverById.firstName.characters">El campo no debe contener caracteres numéricos ni especiales</small>
              </a-form-item>
            </div>
            <div class="col-md">
              <a-form-item label="Apellidos">
                <a-input
                  placeholder="Apellidos"
                  v-model="$v.getDriverById.lastName.$model"
                />
                <small class="text-danger" v-if="!$v.getDriverById.lastName.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!$v.getDriverById.lastName.characters">El campo no debe contener caracteres numéricos ni especiales</small>
              </a-form-item>
            </div>
            </div>
            <div class="col-md-6">
              <a-form-item label="Fecha de nacimiento" has-feedback >
                <a-date-picker placeholder="Seleccionar fecha" @change="changeStartDate" v-model="$v.getDriverById.dateOfBirth.$model" style="width: 100%" />
                <small class="text-danger" v-if="!$v.getDriverById.dateOfBirth.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de tarjetón">
                <a-input placeholder="Número de tarjetón" v-model="$v.getDriverById.cardId.$model" />
                <small class="text-danger" v-if="!$v.getDriverById.cardId.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!validateRegisteredCardId($v.getDriverById.cardId.$model)">Este número de tarjetón ya ha sido registrado previamente. Intenta con uno diferente</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item
                  label="Fecha de Vencimiento del Tarjetón"
                  has-feedback
                >
                  <a-date-picker placeholder="Seleccionar fecha" :disabled-date="disabledDate"  @change="changeTarjetonDate" v-model="$v.getDriverById.cardExpiration.$model" style="width: 100%" />
                  <small class="text-danger" v-if="!$v.getDriverById.cardExpiration.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de licencia">
                <a-input placeholder="Número de licencia" v-model="$v.getDriverById.license.$model" />
                <small class="text-danger" v-if="!$v.getDriverById.license.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!validateRegisteredLicense($v.getDriverById.license.$model)">Este número de licencia ya ha sido registrado previamente. Intenta con uno diferente</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item
                  label="Fecha de Vencimiento de la Licencia"
                  has-feedback
                >
                  <a-date-picker placeholder="Seleccionar fecha" :disabled-date="disabledDate" @change="changeLicenciaDate" v-model="getDriverById.licenseExpiration" style="width: 100%" />
                  <small class="text-danger" v-if="!$v.getDriverById.licenseExpiration.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de teléfono">
                <a-input
                  placeholder="Número de teléfono"
                  v-model="$v.getDriverById.phoneNumber.$model"
                />
                <small class="text-danger" v-if="!validateRegisteredPhone($v.getDriverById.phoneNumber.$model)">Este número de telefono ya ha sido registrado previamente. Intenta con uno diferente.</small><br>
                <small class="text-danger" v-if="!$v.getDriverById.phoneNumber.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!$v.getDriverById.phoneNumber.phoneNumber">El número de teléfono no es válido, no debe contener espacios. Vuelve a intentarlo.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Correo electrónico">
                <a-input
                  placeholder="Correo electrónico"
                  v-model="$v.getDriverById.email.$model"
                />
                <small class="text-danger" v-if="!validateRegisteredEmail($v.getDriverById.email.$model)">Este correo electrónico ya ha sido registrado previamente. Intenta con uno diferente.</small><br>
                <small class="text-danger" v-if="!$v.getDriverById.email.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!$v.getDriverById.email.email">El correo electrónico no es válido, no debe contener espacios. Vuelve a intentarlo.</small>
              </a-form-item>
              <!-- {{ validateRegisteredEmail(getDriverById.email) && validateRegisteredPhone(getDriverById.phoneNumber) && !$v.$invalid }}-->
            </div>
            <div class="col-md-6">
              <a-form-item label="RFC">
                <a-input placeholder="RFC" v-model="$v.getDriverById.rfc.$model"/>
                <small class="text-danger" v-if="!$v.getDriverById.rfc.required">Campo requerido. No debe estar vacío</small><br>
                <small class="text-danger" v-if="!$v.getDriverById.rfc.rfc">El RFC no es válido, no debe contener espacios y tiene que estar en letras mayúsculas. Vuelve a intentarlo.</small><br>
                <small class="text-danger" v-if="!validateRegisteredRFC($v.getDriverById.rfc.$model)">Este RFC ya ha sido registrado previamente. Intenta con uno diferente</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Estado">
                <v-select :options="Object.values(estados)" @input="handleEstadoChange" @select="handleEstadoChange" v-model="$v.getDriverById.address.state.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getDriverById.address.state.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Municipio">
                <v-select :options="Object.keys(municipios)" @input="handleMunicipioChange" @select="handleMunicipioChange" v-model="$v.getDriverById.address.city.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getDriverById.address.city.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Código postal">
                <v-select :options="Object.keys(codigos)" @input="handleCodigoChange" @select="handleCodigoChange" v-model="$v.getDriverById.address.postalCode.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getDriverById.address.postalCode.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Colonia">
                <v-select :options="Object.values(colonias)" v-model="$v.getDriverById.address.suburb.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.getDriverById.address.suburb.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Calle">
                <a-input
                  placeholder="Calle"
                  v-model="$v.getDriverById.address.street.$model"/>
                  <small class="text-danger" v-if="!$v.getDriverById.address.street.required">Campo requerido. No debe estar vacío</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número Exterior">
                <a-input
                  placeholder="Número Exterior"
                  v-model="$v.getDriverById.address.extNumber.$model"/>
                  <small class="text-danger" v-if="!$v.getDriverById.address.extNumber.required">Campo requerido. No debe estar vacío</small>
                  <small class="text-danger" v-if="!$v.getDriverById.address.extNumber.alphaNum">Ingresa un número exterior válido</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número Interior">
                <a-input
                  placeholder="Número Interior"
                  v-model="$v.getDriverById.address.intNumber.$model"/>
                  <small class="text-danger" v-if="!$v.getDriverById.address.intNumber.alphaNum">Ingresa un número interior válido</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!( validateRegisteredCardId($v.getDriverById.cardId.$model) && validateRegisteredRFC($v.getDriverById.rfc.$model) && validateRegisteredLicense($v.getDriverById.license.$model) && validateRegisteredEmail(getDriverById.email) && validateRegisteredPhone(getDriverById.phoneNumber) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                  v-if="this.clicked === 0"
                >
                  Registrar
                </button>
                <b-button class="btn px-5" variant="outline-gray" block  v-else-if="this.clicked === 1">Cargando...</b-button>
                <b-button class="btn px-5" variant="outline-gray" block  v-else-if="this.clicked === 2">Se a registrado exitosamente</b-button>
                <b-button class="btn px-5" variant="outline-danger" block  v-else-if="this.clicked === 3">Ha ocurrido un error</b-button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
      </div> <!--cierra el v-else-->
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import moment from 'moment'
import BaseImageInput from '@/components/imageInput'
import { required, helpers, alphaNum, numeric } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up'
import headers from '@/config/headers.js'
import axios from 'axios'
// import firebase from 'firebase'
moment.locale('es-mx')
const phoneNumber = helpers.regex('phone', /^[0-9]{10}$/)
const characters = helpers.regex('characters', /^[A-Za-z\u00C0-\u017F\s]+$/)
// const rfc = helpers.regex('rfc', /([A-ZÑa-zñ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])([A-Za-z0-9])([A-Za-z0-9])([A-Za-z0-9])?)$/)
// const rfc = helpers.regex('rfc', /^([A-ZÑ&]{3,4}) ?(?:-?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:-?)?([A-Z\d]{2})([A-Z\d])$/)
const rfc = helpers.regex('rfc', /^([A-ZÑ&]{3,4})+?(?:-?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))+?(?:-?)?([A-Z\d]{2})([A-Z\d])$/)
const email = helpers.regex('email', /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/)
const CREATE_DRIVER_MUTATION = gql`
mutation createDriver($cardExpiration: String, $dateOfBirth: String, $firstName: String, $lastName: String, $license: String, $licenseExpiration: String, $phoneNumber: String, $profilePicture: String, $email: String, $cardId: String, $rfc: String, $city: String, $extNumber: String, $intNumber: String, $postalCode: String, $state: String, $suburb: String, $street: String) {
  createDriver(
    driver: {
      dateOfBirth: $dateOfBirth
      cardExpiration: $cardExpiration
      firstName: $firstName
      lastName: $lastName
      license: $license
      licenseExpiration: $licenseExpiration
      phoneNumber: $phoneNumber
      profilePicture: $profilePicture
      email: $email
      cardId: $cardId
      rfc: $rfc
      driverAddress: {
        city: $city
        extNumber: $extNumber
        intNumber: $intNumber
        postalCode: $postalCode
        state: $state
        suburb: $suburb
        street: $street
      }
  }){
    id
    cardExpiration
    firstName
    lastName
    license
    licenseExpiration
    phoneNumber
    profilePicture
    email
    cardId
    active
  }
}`
const DRIVERS_QUERY = gql`
query getDrivers{
  getDrivers{
      id
      active
      cardExpiration
      cardId
      firstName
      lastName
      license
      licenseExpiration
      phoneNumber
      profilePicture
      email
      rfc
  },
}
`
export default {
  apollo: {
    getDrivers: {
      query: gql`query getDrivers{
      getDrivers{
        id
        active
        cardExpiration
        cardId
        firstName
        lastName
        license
        licenseExpiration
        phoneNumber
        profilePicture
        email
        rfc
      },
     }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        console.log(data.getDrivers)
        this.totalRows = data.getDrivers.length
        console.log('Carga terminada')
      },
    },
  },
  data: function() {
    return {
      error: null,
      disableButton: false,
      imageData: null,
      imageLoadData: null,
      selectedActive: '1',
      optionsActive: [
        { text: 'Sí', value: '1' },
        { text: 'No', value: '0' },
      ],
      objectFile: [],
      form: this.$form.createForm(this),
      getDriverById: {
        active: 0,
        cardExpiration: '',
        cardId: '',
        firstName: '',
        lastName: '',
        license: '',
        licenseExpiration: '',
        phoneNumber: '',
        profilePicture: '',
        email: '',
        address: {
          city: '',
          extNumber: '',
          intNumber: '',
          postalCode: '',
          state: '',
          suburb: '',
          street: '',
        },
        rfc: '',
        dateOfBirth: '',
      },
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      clicked: 0,
      registeredEmailDrivers: {},
      registeredPhoneDrivers: {},
      registeredCardId: {},
      registeredLicense: {},
      registeredRFC: {},
      estados: ['Ciudad de México', 'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Coahuila de Zaragoza', 'Colima', 'Chiapas', 'Chihuahua', 'Durango', 'Guanajuato', 'Guerrero',
        'Hidalgo', 'Jalisco', 'México', 'Michoacán de Ocampo', 'Morelos', 'Nayarit', 'Nuevo León',
        'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz de Ignacio de la Llave', 'Yucatán', 'Zacatecas'],
      municipios: [],
      codigos: [],
      colonias: [],
      data: {},
    }
  },
  methods: {
    changeStartDate(event) {
      if (event) {
        this.getDriverById.dateOfBirth = this.defineDate(event._d)
        // console.log(this.tripType)
      } else {
        this.todayDate()
        // this.searchByType(this.tripType)
      }
    },
    validateRegisteredEmail(email) {
      if (this.registeredEmailDrivers[email.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredPhone(phone) {
      if (this.registeredPhoneDrivers['+52' + phone]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredCardId(cardId) {
      if (this.registeredCardId[cardId.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredLicense(license) {
      if (this.registeredLicense[license.trim()]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredRFC(rfc) {
      if (this.registeredRFC[rfc.trim()]) {
        return false
      } else {
        return true
      }
    },
    handleEstadoChange(estado) {
      if (estado === null) {
        this.municipios = []
        this.colonias = []
        this.codigos = []
        this.getDriverById.address.city = ''
        this.getDriverById.address.suburb = ''
        this.getDriverById.address.postalCode = ''
      } else {
        this.data = require(`../../../services/data/${estado}.json`)
        this.municipios = this.data[estado]
        this.getDriverById.address.city = ''
        this.getDriverById.address.suburb = ''
        this.getDriverById.address.postalCode = ''
        this.colonias = []
        this.codigos = []
      }
    },
    handleMunicipioChange(municipio) {
      if (municipio === null) {
        this.codigos = []
        this.colonias = []
        this.getDriverById.address.suburb = ''
        this.getDriverById.address.postalCode = ''
      } else {
        this.colonias = []
        this.codigos = this.data[this.getDriverById.address.state][municipio]
        this.getDriverById.address.suburb = ''
        this.getDriverById.address.postalCode = ''
      }
    },
    handleCodigoChange(codigo) {
      if (codigo === null) {
        this.colonias = []
        this.getDriverById.address.suburb = ''
      } else {
        this.colonias = this.data[this.getDriverById.address.state][this.getDriverById.address.city][codigo]
        this.getDriverById.address.suburb = ''
      }
    },
    defineDate(date) {
      const dates = new Date(date)
      const year = (dates.getFullYear())
      var month = (parseInt(dates.getMonth() + 1))
      var day = (dates.getDate())
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return [year, month, day].join('-')
    },
    changeTarjetonDate(event) {
      if (event) {
        this.getDriverById.cardExpiration = this.defineDate(event._d)
      } else {
        this.todayDate()
      }
    },
    changeLicenciaDate(event) {
      if (event) {
        this.getDriverById.licenseExpiration = this.defineDate(event._d)
      } else {
        this.todayDate()
      }
    },
    async handleSubmit(e) {
      this.clicked = 1
      this.disabledButton = true
      e.preventDefault()
      if (this.imageData != null) {
        this.objectFile.fileExtension = this.imageData.name.split('.').pop()
        this.objectFile.fileUploaded = this.imageData
        const data = await uploadFileS3(this.objectFile)
        this.imageLoadData = data.Location
      }
      // console.log(this.getDriverById.address)
      // console.log(this.imageLoadData)
      this.$apollo.mutate({
        mutation: CREATE_DRIVER_MUTATION,
        variables: {
          cardExpiration: this.getDriverById.cardExpiration,
          firstName: this.getDriverById.firstName,
          lastName: this.getDriverById.lastName,
          license: this.getDriverById.license.trim(),
          licenseExpiration: this.getDriverById.licenseExpiration,
          phoneNumber: '+52' + this.getDriverById.phoneNumber,
          profilePicture: this.imageLoadData,
          email: this.getDriverById.email.trim(),
          cardId: this.getDriverById.cardId.trim(),
          rfc: this.getDriverById.rfc.trim(),
          city: this.getDriverById.address.city,
          extNumber: this.getDriverById.address.extNumber,
          intNumber: this.getDriverById.address.intNumber,
          postalCode: this.getDriverById.address.postalCode,
          state: this.getDriverById.address.state,
          suburb: this.getDriverById.address.suburb,
          street: this.getDriverById.address.street,
          dateOfBirth: this.getDriverById.dateOfBirth,
        },
        context: headers(),
      })
        .then(({ data }) => {
          this.clicked = 2
          data.createDriver.driverAddress = {
            city: this.getDriverById.address.city,
            extNumber: this.getDriverById.address.extNumber,
            intNumber: this.getDriverById.address.intNumber,
            postalCode: this.getDriverById.address.postalCode,
            state: this.getDriverById.address.state,
            suburb: this.getDriverById.address.suburb,
            street: this.getDriverById.address.street,
          }
          console.log(data.createDriver, 'conductor creado')
          this.goListDrivers()
          axios({
            method: 'put',
            url: 'https://newaccount1617024997354.freshdesk.com/api/v2/contacts',
            body: {
              id: data.createDriver.id,
              name: this.getDriverById.firstName + ' ' + this.getDriverById.lastName,
              mobile: '+52' + this.getDriverById.phoneNumber,
              email: this.getDriverById.email.trim(),
              fecha_de_nacimiento: this.getDriverById.dateOfBirth,
              custom_fields: {
                rfc: this.getDriverById.rfc.trim(),
                fecha_de_vencimiento_del_tarjetn: this.getDriverById.cardExpiration,
                nmero_de_tarjetn: this.getDriverById.cardId.trim(),
                id_de_la_licencia: this.getDriverById.license.trim(),
                fecha_de_vencimiento_de_la_licencia: this.getDriverById.licenseExpiration,
                cp: this.getDriverById.address.postalCode,
                ciudad: this.getDriverById.address.city,
                no_exterior: this.getDriverById.address.extNumber,
                no_interior: this.getDriverById.address.intNumber,
                estado: this.getDriverById.address.state,
                colonia: this.getDriverById.address.suburb,
                calle: this.getDriverById.address.street,
              },
            },
            auth: {
              username: 'I6N50w2FTsSQYvqj2',
              password: 'x',
            },
          })
          // firebase.firestore().collection('drivers').doc(String(data.createDriver.id)).set({
          //   fare: false,
          //   found: false,
          //   active: false,
          //   free: false,
          //   onTrip: false,
          //   token: '',
          //   rate: {
          //     active: false,
          //     passenger: null,
          //     rating: 0.0,
          //   },
          //   driver: data.createDriver,
          //   location: null,
          //   authenticated: false,
          //   created_at: new Date().toISOString(),
          // })
          //   .then(data => {
          //     this.$router.push('/conductores/getDrivers')
          //   })
          //   .catch(error => {
          //     console.log(error)
          //   })
        })
        .catch(error => {
          this.clicked = 3
          this.disabledButton = false
          console.log(error.message)
          if (error.message.includes('An account with the given phone_number already exists')) {
            this.mensaje.texto = 'El teléfono que intentas registrar ya existe'
            this.mensaje.color = 'warning'
            this.showAlert()
          } else {
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          }
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    disabledDate(current) {
      return current < moment().add(-1, 'days')
    },
    goListDrivers() {
      this.$router.push('/conductores/getDrivers')
    },
  },
  created() {
    this.$apollo.query({ query: DRIVERS_QUERY, context: headers() })
      .then(({ data }) => {
        // console.log(data.getDrivers)
        data.getDrivers.forEach(driver => {
          this.registeredEmailDrivers[driver.email] = 1
          this.registeredPhoneDrivers[driver.phoneNumber] = 1
          this.registeredCardId[driver.cardId] = 1
          this.registeredLicense[driver.license] = 1
          this.registeredRFC[driver.rfc] = 1
        })
        // console.log(this.registeredEmailDrivers)
      })
      .catch(error => {
        console.log(error)
      })
  },
  validations: {
    imageData: { required },
    getDriverById: {
      dateOfBirth: { required },
      firstName: { required, characters },
      lastName: { required, characters },
      cardExpiration: { required },
      cardId: { required },
      phoneNumber: { required, phoneNumber },
      email: { required, email },
      license: { required },
      licenseExpiration: { required },
      rfc: { required, rfc },
      address: {
        city: { required },
        state: { required },
        extNumber: { required, alphaNum },
        intNumber: { alphaNum },
        postalCode: { required, numeric },
        suburb: { required },
        street: { required },
      },
    },
  },
  components: {
    BaseImageInput,
  },
}
</script>
